<button
  type="button"
  class="ntrig"
  [class.is-open]="open"
  [class.has-unread]="snapshot.unreadCount > 0"
  aria-label="Notifications"
  [attr.aria-expanded]="open"
  (click)="toggle($event)"
>
  <i class="pi pi-bell"></i>
  @if (snapshot.unreadCount > 0) {
    <span class="ntrig__dot">{{ snapshot.unreadCount > 9 ? '9+' : snapshot.unreadCount }}</span>
  }
</button>

@if (open) {
  <div class="npanel" role="dialog" aria-label="Notifications" (click)="$event.stopPropagation()">
    <div class="npanel__glow" aria-hidden="true"></div>

    <header class="npanel__head">
      <div>
        <p class="npanel__eyebrow">Live desk</p>
        <div class="npanel__title-row">
          <h2>Inbox</h2>
          @if (snapshot.unreadCount > 0) {
            <span class="npanel__count">{{ snapshot.unreadCount }}</span>
          }
        </div>
      </div>
      <div class="npanel__actions">
        <button
          type="button"
          class="npanel__icon"
          [class.is-on]="!soundMuted"
          [title]="soundMuted ? 'Unmute alerts' : 'Mute alerts'"
          (click)="toggleSound($event)"
        >
          <i class="pi" [ngClass]="soundMuted ? 'pi-volume-off' : 'pi-volume-up'"></i>
        </button>
        <button type="button" class="npanel__icon" title="Refresh" (click)="refresh($event)">
          <i class="pi pi-refresh" [class.spin]="snapshot.loading"></i>
        </button>
      </div>
    </header>

    <div class="npanel__seg" role="tablist" aria-label="Filter notifications">
      @for (entry of filters; track entry.id) {
        <button
          type="button"
          role="tab"
          class="npanel__seg-btn"
          [class.is-active]="filter === entry.id"
          [attr.aria-selected]="filter === entry.id"
          (click)="setFilter(entry.id, $event)"
        >
          {{ entry.label }}
          <span>{{ filterCounts[entry.id] }}</span>
        </button>
      }
    </div>

    <div class="npanel__toolbar">
      <div class="npanel__toolbar-left">
        <button
          type="button"
          class="npanel__text-btn"
          [disabled]="!snapshot.unreadCount"
          (click)="markAllRead($event)"
        >
          Mark all read
        </button>
        @if (snapshot.unreadCount > 0) {
          <span class="npanel__unread-hint">{{ snapshot.unreadCount }} unread</span>
        }
      </div>
      <span class="npanel__sync">
        <i class="pi pi-clock"></i>
        {{ updatedLabel }}
      </span>
    </div>

    <div class="npanel__feed">
      @if (snapshot.loading && !filteredItems.length) {
        @for (_ of [1, 2, 3, 4]; track _) {
          <div class="npanel__skel">
            <i></i>
            <div>
              <span></span>
              <span></span>
            </div>
          </div>
        }
      } @else if (snapshot.error && !filteredItems.length) {
        <div class="npanel__empty">
          <div class="npanel__empty-ico">
            <i class="pi pi-exclamation-circle"></i>
          </div>
          <strong>Couldn’t load</strong>
          <p>{{ snapshot.error }}</p>
          <button type="button" (click)="refresh($event)">Try again</button>
        </div>
      } @else if (!filteredItems.length) {
        <div class="npanel__empty">
          <div class="npanel__empty-ico is-ok">
            <i class="pi pi-check"></i>
          </div>
          <strong>You’re caught up</strong>
          <p>New clinic activity will show up here.</p>
        </div>
      } @else {
        @for (item of filteredItems; track item.id) {
          <article
            class="npanel__card"
            [class.is-unread]="!item.read"
            [ngClass]="'tone-' + item.category"
            (click)="openItem(item, $event)"
          >
            <div class="npanel__card-ico">
              <i class="pi" [ngClass]="iconFor(item)"></i>
            </div>
            <div class="npanel__card-body">
              <div class="npanel__card-meta">
                <span>{{ labelFor(item) }}</span>
                <time>{{ timeFor(item) }}</time>
              </div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.detail }}</p>
            </div>
            <div class="npanel__card-side">
              @if (!item.read) {
                <button
                  type="button"
                  class="npanel__mark"
                  title="Mark as read"
                  (click)="markItemRead(item, $event)"
                >
                  <i class="pi pi-check"></i>
                </button>
              } @else {
                <span class="npanel__read-tag" title="Read">
                  <i class="pi pi-check"></i>
                </span>
              }
              @if (item.dismissible) {
                <button
                  type="button"
                  class="npanel__dismiss"
                  title="Dismiss"
                  (click)="dismissItem(item, $event)"
                >
                  <i class="pi pi-times"></i>
                </button>
              } @else {
                <i class="pi pi-angle-right npanel__chev" aria-hidden="true"></i>
              }
            </div>
          </article>
        }
      }
    </div>

    <footer class="npanel__foot">
      <span [class.is-muted]="soundMuted">
        <i class="pi" [ngClass]="soundMuted ? 'pi-volume-off' : 'pi-volume-up'"></i>
        {{ soundMuted ? 'Alerts muted' : 'Sounds on for new alerts' }}
      </span>
    </footer>
  </div>
}
